export default __webpack_public_path__ + "static/media/card-danger.8cb1a52f.png";